import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { PostAbschnittCommandService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [PostAbschnittCommandService],
  exports: []
})
export class PostAbschnittCommandServiceModule { }
